import { ApiService } from "./ApiService";
import { Debtor } from "../types/Debtor";
import Cookies from "js-cookie";

const baseUrl = "/services/login/api";
const XSRF_TOKEN_COOKIE_NAME = "XSRF-TOKEN";

class UserService extends ApiService {
    async verifyUser(debtNumber: string, firstName: string, lastName: string): Promise<Debtor> {
        const request = Object.assign({ firstName: firstName }, { lastName: lastName });
        const response = await fetch(baseUrl + "/user/" + debtNumber + "/verifyuser", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(request),
        });
        const verifyUserResponse = await this.handleResponse(response);
        return verifyUserResponse.json();
    }

    async loginWithDebtNumber(debtNumber: string): Promise<string> {
        const formData = new URLSearchParams();
        formData.append("debtNumber", debtNumber);

        const response = await fetch(baseUrl + "/token/debt", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-XSRF-TOKEN": Cookies.get(XSRF_TOKEN_COOKIE_NAME) as string,
            },
            body: formData,
        });

        const result = await this.handleResponseWithoutRedirect(response);
        return result.toString();
    }
}

export default new UserService();
